import { initializeApp } from "firebase/app";
import { 
  updateProfile, 
  getAuth, 
  signInWithEmailAndPassword, 
  onAuthStateChanged, 
  reauthenticateWithCredential,  
  EmailAuthProvider              
} from "firebase/auth";

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCJeKUH9l91MxOaIHMNjdWBmhG5ubqObb0",
  authDomain: "choky-a0674.firebaseapp.com",
  projectId: "choky-a0674",
  storageBucket: "choky-a0674.firebasestorage.app",
  messagingSenderId: "59248887282",
  appId: "1:59248887282:web:8430f1803f46fec279976b"
};

// Inicializar Firebase y Realtime Database
const app = initializeApp(firebaseConfig);

// Exportar las funciones necesarias
export { 
  app, 
  updateProfile, 
  getAuth, 
  signInWithEmailAndPassword, 
  onAuthStateChanged, 
  reauthenticateWithCredential,  
  EmailAuthProvider              
};
